//Tous les appels constants
const genres = document.querySelector('.genres');
const moviesList = document.querySelector('.movies');
const moviesListSearch = document.querySelector('#movies--search');
const backBtn = document.querySelectorAll('.btn--back');
const searchInput = document.querySelector(".search__field");
const navBtn = document.querySelectorAll('.nav__el');
const bookmarkBTN = document.querySelector('#bookmark');
const btnClose = document.getElementById('closeList');
const title = document.querySelector('.title__change');
let openedSectionBefore;   
let timeout;
var pageIndex = 1;

//Tous les liens utilisés
const urlBase = 'https://www.jeanchristophewieme.be/projets/movie-wishlist/api/';
const urlGenre = 'https://www.jeanchristophewieme.be/projets/movie-wishlist/api/discover/movie&sort_by=popularity.desc&include_adult=false&include_video=false';
const urlUpcoming = 'https://www.jeanchristophewieme.be/projets/movie-wishlist/api/movie/upcoming';
const urlFilm = 'https://www.jeanchristophewieme.be/projets/movie-wishlist/api/movie/';

//Création de la liste des genres avec attribution de l'id
fetch(urlBase + 'genre/movie/list')
    .then(response => response.json())
    .then(json => {
        let cacheGenres = json.genres;

        for (genre of cacheGenres) {
            let genresEl = document.createElement('li');
            genresEl.classList.add('genres__el');
            genresEl.setAttribute("data-genre-id", genre.id);
            genresEl.innerHTML = `${genre.name}`;

            genres.appendChild(genresEl);

            genresEl.addEventListener("click", (e) => {
                document.querySelector('.genres__el--active').classList.remove('genres__el--active');
                e.currentTarget.classList.add('genres__el--active');
                displayMovies(e.currentTarget.getAttribute("data-genre-id"), pageIndex);
            });
        }
    });

displayMovies('upcoming', pageIndex);

//Navigation des bouttons
for (btn of navBtn) {
    btn.addEventListener('click', (e) => {
        let idPage = e.currentTarget.getAttribute('data-link');
        setActiveSection(idPage);
    });
}

//Ajout du upcoming qui ne se trouve pas dans la liste des genres générés par l'api
document.querySelector('#upcoming').addEventListener('click', (e) => {
    document.querySelector('.genres__el--active').classList.remove('genres__el--active');
    e.currentTarget.classList.add('genres__el--active');
    displayMovies(e.currentTarget.getAttribute("data-genre-id"), pageIndex);
});

//Bouton retour de chaque page
for(btn of backBtn){
    btn.addEventListener('click', (e) => {   
        e.preventDefault();
        if(e.currentTarget.getAttribute('data-back-btn') !== 'search'){
            searchInput.value = "";
            if(searchInput.classList.contains('search__field--active')){
                searchInput.classList.remove('search__field--active');
                moviesListSearch.innerHTML = "";
            }
        }
        
        setActiveSection(e.currentTarget.getAttribute('data-back-btn'));
    });
}

//Go to index when clicking title
document.querySelector('#title').addEventListener('click', (e) => {
    setActiveSection('index');
});

//Check de btn createlist
document.getElementById('addList').addEventListener('click', (e) => {
    createList();
});

btnClose.addEventListener('click', (e) => { 
    document.body.setAttribute('data-list', 'close');
});

//Affichage des films par genre
function displayMovies(genre, pageNumber) {
    let cacheUrlDisplay = urlGenre;
    let cacheMovies = [];
    let cacheMoviesAfter = [];

    if (genre !== document.body.getAttribute('data-movie-genre')) {
        pageNumber = 1;
        pageIndex = 1;
        moviesList.innerHTML = '';
    }

    if (!genre || genre === 'upcoming') {
        cacheUrlDisplay = urlUpcoming + `&page=${pageNumber}`;
    } else {
        cacheUrlDisplay += `&with_genres=${genre}&page=${pageNumber}`;
    }

    fetch(cacheUrlDisplay)
        .then(response => response.json())
        .then(json => {
            cacheMovies = json.results;

            for (movie of cacheMovies) {
                let posterUrl = "assets/images/404--small.jpg";

                if (movie.poster_path) {
                    posterUrl = "https://image.tmdb.org/t/p/w154" + movie.poster_path;
                }

                let movieEl = document.createElement('li');
                movieEl.classList.add('movies__el');
                movieEl.setAttribute("data-movie-id", movie.id);
                movieEl.innerHTML = `<img src="${posterUrl}" alt="${movie.original_title}" />`;

                moviesList.appendChild(movieEl);

                movieEl.addEventListener('click', (e) => {
                    displayMovie(e.currentTarget.getAttribute("data-movie-id"));
                });

                document.body.setAttribute("data-movie-genre", genre);
            }
        });
};

//Affichage d'un film spécifique
function displayMovie(id) {
    openedSectionBefore = document.querySelector('.page--open');
    openedSectionBefore = openedSectionBefore.getAttribute('data-page-name');
    let btnBackM = document.querySelector('.btn--backmovie');
    btnBackM.setAttribute('data-back-btn', openedSectionBefore);
    
    setActiveSection("movie");
    
    document.body.setAttribute("data-movie-load", "loading");
    let url = urlFilm + id;
    let cacheGender = [];
        
    checkBookmark(id);

    fetch(url)
        .then(response => response.json())
        .then(json => {
            let posterUrl = "assets/images/404.jpg";
            let logoCompany = "assets/images/404.jpg";
            let nameCompany = 'error';

            if (json.poster_path) {
                posterUrl = "https://image.tmdb.org/t/p/w500" + json.poster_path;
            }

            if (json.production_companies.length >= 1) { 
                if (json.production_companies[0].logo_path === null) {
                    logoCompany = logoCompany;
                } else {
                    logoCompany = "https://image.tmdb.org/t/p/w154" + json.production_companies[0].logo_path;
                }

                nameCompany = json.production_companies[0].name;
            }

            let movieDescription = document.querySelector('.movie__description');
            let movieStudio = document.querySelector('.movie__studio');
            let movieDate = document.querySelector('.movie__date');
            let movieHead = document.querySelector('.movie__head');
            let movieTitle = document.querySelector('.movie__headtitle');
            let movieGenre = document.querySelector('.movie__genre');

            cacheGender = json.genres.slice(0, 5);
            movieGenre.innerHTML = '';

            movieHead.style.background = `url(${posterUrl}), rgba(0,0,0,0.5)`;
            movieHead.style.backgroundRepeat = 'no-repeat';
            movieHead.style.backgroundSize = 'cover';
            movieHead.style.backgroundPosition = 'top center';
            movieDescription.innerHTML = json.overview;
            movieTitle.innerHTML = json.title;
            movieStudio.innerHTML = `<h3>Studio</h3><p>${nameCompany}<p><img src='${logoCompany}' alt='${nameCompany}'>`;
            movieDate.innerHTML = `<h3>Release</h3><p>${json.release_date}</p><h3>Budget</h3><p>${json.budget}$</p>`;
            bookmarkBTN.setAttribute("data-movie-id", id);

            for (genre of cacheGender) {
                let liEl = document.createElement('li');
                liEl.innerHTML = genre.name;
                movieGenre.appendChild(liEl);
            };

            document.body.setAttribute("data-movie-load", "loaded");
        });
};

//Storage in the list
bookmarkBTN.addEventListener('click', (e) => {
    loadList(e.currentTarget.getAttribute('data-movie-id'));
});

//Quel page est ouverte
function setActiveSection(name) {
    let animSIn = document.querySelectorAll('.animIn');
    let animSOut = document.querySelectorAll('.animOut');
    
    for(x of animSIn){
        x.classList.remove('animIn');
    }
    
    for(x of animSOut){
        x.classList.remove('animOut');
    }
    
    let openedSection = document.querySelector(".page--open");

    if (openedSection) {
        openedSection.classList.remove("page--open");
        openedSection.classList.add('animOut');
    }

    let openSection = document.querySelector(".page--" + name);
    
    title.innerHTML = "popcorn";

    if (name === 'lists') {
        loadLists();
    }

    if (openSection) {
        if(name === 'movie'){
            openSection.classList.add("page--open");
            openSection.classList.add('animMIn');
        }else{
            openSection.classList.add("page--open");
            openSection.classList.add('animIn');
        }
    }

    document.body.setAttribute('data-page-open', name);
    document.body.setAttribute('data-list-see', 'false');
    document.body.setAttribute('data-movie-load', 'wait');
    document.body.setAttribute('data-list', 'close');
}

//Search input listening
searchInput.addEventListener('click', (e) => {
    if (searchInput.value || (searchInput.value && searchInput.activeElement)) {
        return;
    }

    e.currentTarget.classList.toggle('search__field--active');
});

//Search code
searchInput.addEventListener("input", (e) => {

    clearTimeout(timeout);

    timeout = setTimeout(() => {

        let value = searchInput.value;

        if (!value) {
            moviesListSearch.innerHTML = '';
            return;
        }

        // encodeURI permet d'encoder la valeur en paramètre GET.
        let url = urlBase + 'search/movie?query=' + encodeURI(value);

        fetch(url)
            .then(response => response.json())
            .then(json => {
                moviesListSearch.innerHTML = '';
                let filteredMovies = json.results.slice(0, 10);

                for (movie of filteredMovies) {
                    let posterUrl = "assets/images/404--small.jpg";

                    if (movie.poster_path) {
                        posterUrl = "https://image.tmdb.org/t/p/w154" + movie.poster_path;
                    }

                    let movieEl = document.createElement('li');
                    movieEl.classList.add('movies__el');
                    movieEl.setAttribute("data-movie-id", movie.id);
                    movieEl.innerHTML = `<img src="${posterUrl}" alt="${movie.original_title}" />`;

                    moviesListSearch.appendChild(movieEl);

                    movieEl.addEventListener('click', (e) => {
                        displayMovie(e.currentTarget.getAttribute("data-movie-id"));
                    });
                }

            });

    }, 250);

});

//LoadMore Function
function loadMore() {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
        pageIndex++;
        displayMovies(document.body.getAttribute('data-movie-genre'), pageIndex);
    }, 100);
};

//Infinite scroll
document.addEventListener("scroll", function (event) {
    checkForScroll();
});
var checkForScroll = function () {
    var listContent = moviesList;
    var listContentOffset = listContent.offsetTop + listContent.clientHeight;
    var pageOffset = window.pageYOffset + window.innerHeight;

    if (pageOffset > listContentOffset - 20) {
        loadMore();
    }
};

//Lists

//Add to default list function
function addToList(id, listName) {
    let numbers = [];
    let storage = JSON.parse(localStorage.getItem(listName));
    let boolCheck = false;

    if (storage) {
        if (storage.constructor === Array) {
            for (let i = 0; i < storage.length; i++) {
                if (storage[i] === id) {
                    boolCheck = true;
                }
                numbers.push(storage[i]);
            }
        } else {
            if (storage === id) {
                boolCheck = true;
            }
            numbers.push(storage);
        }

        if (boolCheck === true) {
            document.body.setAttribute('data-list', 'close');
            return;
        } else {
            numbers.push(id);
        }
        localStorage.setItem(listName, JSON.stringify(numbers));
    }
    
    checkBookmark(id);

    document.body.setAttribute('data-list', 'close');
}

//Load list on bookmark click
function loadList(id) {
    if (localStorage.length === 0) {
        return;
    } else {
        let list = document.getElementById('movieList');
        list.innerHTML = '';

        for (let i = 0; i < localStorage.length; i++) {
            
            let liEl = document.createElement('li');
            liEl.setAttribute('data-list-name', localStorage.key(i));
            liEl.classList.add('movie__listEL');
            
            let divIMG = document.createElement('div');
            divIMG.classList.add('movie__listIMGCONTENT');
            
            let divTitle = document.createElement('div');
            divTitle.classList.add('movie__listTITLE');
            divTitle.innerHTML = `<p>${localStorage.key(i)}</p>`;
            
            if (localStorage.key(i) !== 'randid') {
                let nameStore = localStorage.key(i);
                let itemStore = localStorage.getItem(nameStore);
                itemStore = JSON.parse(itemStore);
                let posterUrl = "assets/images/404--small.jpg";
                
                for(let j = 0; j < itemStore.length; j++){
                   if(itemStore[j] !== 1 && j < 4){
                       fetch(urlFilm + itemStore[j])
                        .then(response => response.json())
                        .then(json => {

                           if (json.poster_path) {
                               posterUrl = "https://image.tmdb.org/t/p/w154" +     json.poster_path;
                           }
                           
                           let imgEl = document.createElement('img');
                           imgEl.classList.add('movie__listIMG');
                           imgEl.setAttribute('src', posterUrl);
                           imgEl.setAttribute('alt', json.original_title);
                           
                           divIMG.appendChild(imgEl);
                       });
                   }
                }
                
                if(itemStore.length === 1){
                    let imgEl = document.createElement('img');
                    imgEl.classList.add('movie__listIMG');
                    imgEl.setAttribute('src', posterUrl);
                    imgEl.setAttribute('alt', 'to be found');
                    divIMG.appendChild(imgEl);
                }
                
                liEl.appendChild(divIMG);
                liEl.appendChild(divTitle)
                list.appendChild(liEl);
            }

            liEl.addEventListener('click', (e) => {
                addToList(id, e.currentTarget.getAttribute('data-list-name'));
            });

        }
    }
    
    
    clearTimeout(timeout);

    timeout = setTimeout(() => {
        document.body.setAttribute('data-list', 'open');
    }, 300);
}

//Create list
function createList() {
    document.body.setAttribute('data-list-creation', 'true');
    document.querySelector('.listbox__form').addEventListener('submit', (e) => {
        e.preventDefault();
        let field = document.querySelector('.listbox__field');
        let fieldValue = field.value;
        
        if(fieldValue.length === 0){
            document.body.setAttribute('data-list', 'close');
            document.body.setAttribute('data-list-creation', 'false');
            return;
        }
        
        localStorage.setItem(fieldValue, '1');
        loadList(bookmarkBTN.getAttribute('data-movie-id'));
        document.body.setAttribute('data-list-creation', 'false');
    });
}

//Load Lists in the page
function loadLists() {
    if (localStorage.length === 0) {
        return;
    } else {
        let list = document.querySelector('.lists__list');
        list.innerHTML = '';

        for (let i = 0; i < localStorage.length; i++) {
            let liEl = document.createElement('li');
            liEl.classList.add('lists__el');
            
            let contentDiv = document.createElement('div');
            contentDiv.classList.add('lists__content');
            
            let pEl = document.createElement('p');
            pEl.innerHTML = `${localStorage.key(i)}`;
            
            let btnEl = document.createElement('button');
            btnEl.classList.add('btn--delete');
            btnEl.setAttribute('data-list-id', localStorage.key(i));
            
            let iEl = document.createElement('i');
            iEl.classList.add('material-icons');
            iEl.innerHTML = "delete";
            
            let ulEl = document.createElement('ul');
            ulEl.classList.add('listbox__inMovie');
            ulEl.id = localStorage.key(i);
            ulEl.setAttribute('data-list-movie', localStorage.key(i));
            
            btnEl.appendChild(iEl);
            contentDiv.appendChild(pEl).appendChild(btnEl);
            
            liEl.appendChild(contentDiv).appendChild(ulEl);
            
            if (localStorage.key(i) !== 'randid') {
                list.appendChild(liEl); 
                let name = document.getElementById(`${localStorage.key(i)}`)
                displayMovieInLists(name.getAttribute('data-list-movie'));
            }

            ulEl.addEventListener('click', (e) => {
                displayMovieInList(e.currentTarget.getAttribute('data-list-movie'));
            });
            
            btnEl.addEventListener('click', (e) => {
                document.body.setAttribute('data-list-delete', 'true');
                
                let btnYes = document.getElementById('yes');
                let btnNo = document.getElementById('no');
                
                btnYes.setAttribute('data-id', e.currentTarget.getAttribute('data-list-id'));
                
                btnYes.addEventListener('click', (e) => {
                    localStorage.removeItem(e.currentTarget.getAttribute('data-id'));
                    document.body.setAttribute('data-list-delete', 'false');
                    loadLists();
                });
                
                btnNo.addEventListener('click', (e) => {
                    document.body.setAttribute('data-list-delete', 'false');
                });
            });
        }
    }
}

//Display a selected list
function displayMovieInList(name) {
    let contentMovieList = document.querySelector('.lists__inMovie');

    let storage = localStorage.getItem(name);
    storage = JSON.parse(storage);
    
    title.innerHTML = name;

    if (storage.length === undefined) {
        return;
    } else {
        document.body.setAttribute('data-list-see', 'true');
        contentMovieList.innerHTML = "";
        for (movie of storage) {
            if (movie !== 1) {
                let url = urlFilm + movie;

                fetch(url)
                    .then(response => response.json())
                    .then(json => {
                        let posterUrl = "assets/images/404--small.jpg";

                        if (json.poster_path) {
                            posterUrl = "https://image.tmdb.org/t/p/w154" + json.poster_path;
                        }

                        let movieEl = document.createElement('li');
                    
                        let imgEL = document.createElement('img');
                        imgEL.setAttribute('src', posterUrl);
                        imgEL.setAttribute('alt', json.original_title);
                        imgEL.setAttribute("data-movie-id", json.id);
            
                        let btnEl = document.createElement('button');
                        btnEl.classList.add('btn--delete');
                        btnEl.setAttribute('data-movieDel-id', json.id);
            
                        let iEl = document.createElement('i');
                        iEl.classList.add('material-icons');
                        iEl.innerHTML = "delete";
                    
                        btnEl.appendChild(iEl);
                        movieEl.appendChild(imgEL);
                        movieEl.appendChild(btnEl);

                        contentMovieList.appendChild(movieEl);

                        imgEL.addEventListener('click', (e) => {
                            displayMovie(e.currentTarget.getAttribute("data-movie-id"));
                        });
                    
                        btnEl.addEventListener('click', (e) => {
                            
                            document.body.setAttribute('data-list-delete', 'true');
                 
                            let btnYes = document.getElementById('yes');
                            let btnNo = document.getElementById('no');
                 
                            btnYes.setAttribute('data-id', e.currentTarget.getAttribute('data-movieDel-id'));
                
                            btnYes.addEventListener('click', (e) => {
                                deleteMovieFromList(e.currentTarget.getAttribute('data-id'), name);
                                document.body.setAttribute('data-list-delete', 'false');
                            });
                
                            btnNo.addEventListener('click', (e) => {
                                document.body.setAttribute('data-list-delete', 'false');
                            });
                        });
                });
            };
        };
    };
};

//Display Movie in the list
function displayMovieInLists(name){
    let content = document.querySelector(`[data-list-movie="${name}"]`);
    
    let storeMe = localStorage.getItem(name);
    storeMe = JSON.parse(storeMe);
    
    if (storeMe.length === undefined) {
        return;
    } else {
        content.innerHTML = "";
        for (movie of storeMe) {
            if (movie !== 1) {
                let url = urlFilm + movie;

                fetch(url)
                    .then(response => response.json())
                    .then(json => {
                        let posterUrl = "assets/images/404--small.jpg";

                        if (json.poster_path) {
                            posterUrl = "https://image.tmdb.org/t/p/w154" + json.poster_path;
                        }

                        let movieEl = document.createElement('li');
                        movieEl.setAttribute("data-movie-id", json.id);
                        movieEl.innerHTML = `<img src="${posterUrl}" alt="${json.original_title}" />`;

                        content.appendChild(movieEl);
                });
            };
        };
    };
}

// Setup isScrolling variable
var isScrolling;
window.addEventListener('scroll', function (event) {
    window.clearTimeout(isScrolling);
    isScrolling = setTimeout(function () {
        if (window.scrollY === 0) {
            document.body.setAttribute('data-scroll', 'close');
            return;
        } else {
            document.body.setAttribute('data-scroll', 'scroll');
        }
    }, 66);
}, false);

function scrollIt(element) {
    window.scrollTo({
        'behavior': 'smooth',
        'left': 0,
        'top': element.offsetTop
    });
};

document.querySelector('.page__return').addEventListener('click', (e) => {
    let toTop = document.querySelector('.header');
    document.body.setAttribute('data-scroll', 'none');
    scrollIt(toTop);
});

function checkBookmark(id) {
    let bool = false;
    
    for(let i =0; i < localStorage.length; i++){
        if(localStorage.key(i) !== 'randid'){
            let storage = JSON.parse(localStorage.getItem(localStorage.key(i)));
            let numbers = [];
            
            if(storage){
                for(let j = 0; j < storage.length; j++){
                    if(id === storage[j]){
                        bool = true;
                    }
                }
            }
        }
    }
    
    if(bool){
        bookmarkBTN.firstChild.innerHTML = "bookmark";
    }else{
        bookmarkBTN.firstChild.innerHTML = "bookmark_border";
    }
}

function deleteMovieFromList(id, name) {
    let storage = JSON.parse(localStorage.getItem(name));
    
    if(storage){
        for(let i = 0; i < storage.length; i++){
            if(storage[i] === id){
                storage.splice(i, 1);
            }
        }
    }
    
    storage = JSON.stringify(storage);
    localStorage.setItem(name, storage);
    
    displayMovieInList(name);
}

//Snippet to open in a new tab as a mobile
document.getElementById("desktop").addEventListener("click", function(e) {
    e.preventDefault();
    myWindow = window.open("index.html", "", "width=100, height=100"), myWindow.resizeTo(414, 736), myWindow.focus()
});
